import {Component} from '@angular/core';

@Component({
  selector: 'app-cookies-policy',
  templateUrl: './cookies-policy.component.html'
})
export class CookiesPolicyComponent {

}
